import { Vector2Tuple } from 'three';

import { GraphNodeImpl } from '@spazious/dollhouse-graph';
import { FShallowBase } from '@spazious/dollhouse-shallow-graph';

import { FNode, FNodeBase, FNodeChild, FNodeParent, FNodeRoot } from '../types/index.js';
import { applyProps } from '../utils/index.js';

export abstract class BaseNodeImpl
  extends GraphNodeImpl<FNodeRoot, FNodeParent, FNodeChild>
  implements FNodeBase
{
  position: Vector2Tuple = [0, 0];
  rotation: number = 0;
  selector: string = null!;
  shallowParent?: string | null = null;
  positionY: number = 0;
  shallow: FShallowBase | null = null;
  applyProps(props: any): void {
    applyProps(this as any, props);
  }
  /**
   * Find a node by its selector
   */
  findBySelector(selector: string): FNode | null {
    if (this.selector === selector) {
      return this as unknown as FNode;
    }
    for (let i = 0; i < this.children.length; i++) {
      const child = this.children[i] as FNode;
      const found = child.findBySelector(selector);
      if (found) {
        return found as FNode;
      }
    }
    return null;
  }
}
